import { render } from "./pb-participantsvolet.vue?vue&type=template&id=c898e584"
import script from "./pb-participantsvolet.vue?vue&type=script&lang=js"
export * from "./pb-participantsvolet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__